<template>
	<div id="app">
		<div v-if="!isProcessing">
			<app-navbar />

			<main class="vh-margin-medium-top vh-margin-xlarge-bottom">
                <div class="vh-container vh-container-large">
                    <router-view />
                </div>
			</main>

			<app-footer/>
		</div>

		<div class="vh-splashscreen" v-else>
			<img class="vh-splashscreen-logo" src="/static/assets/img/vh-emblem.svg">
		</div>

        <notifications
            group="notification"
            position="bottom right" />
	</div>
</template>

<style lang="scss">
    @import "./scss/app";
    @import url('https://fonts.googleapis.com/css?family=Poppins');
	@import url('https://maxcdn.icons8.com/fonts/line-awesome/1.1/css/line-awesome-font-awesome.min.css');
</style>

<script>
import { mapGetters, mapActions } from 'vuex';

// layout
import AppNavbar from '@/views/layouts/navbar';
import AppFooter from '@/views/layouts/footer';

export default 
{
	name: 'App',

	components: 
	{
		AppNavbar,
		AppFooter
	},

	computed:
	{
        ...mapGetters({
            isProcessing: 'auth/isProcessing',
            accessUser: 'auth/accessUser',
        }),
        
        hasAccessUser: function()
        {
            return Object.keys(this.accessUser).length > 0;
        }
    },
}
</script>

<style>
	body { font-family: Poppins; }
</style>



// WEBPACK FOOTER //
// src/App.vue